<template>
  <div :class="_.timer">
    <div :class="_.item">{{ seckillInfo.diff.h }}</div>
    <div :class="_.divider" />
    <div :class="_.item">{{ seckillInfo.diff.i }}</div>
    <div :class="_.divider" />
    <div :class="_.item">{{ seckillInfo.diff.s }}</div>
  </div>
</template>

<script>
  import { computed } from '@vue/composition-api'
  import { defineClassComponent } from '@/hooks'
  import { goodsProvider } from '@/views/goods/provider'

  export default defineClassComponent(
    () =>
      class {
        // 商品数据
        goodsData = goodsProvider.inject()

        // 秒杀信息
        seckillInfo = computed(() => this.goodsData.value.seckillInfo)
      },
  )
</script>

<style lang="scss" module>
  .timer {
    display: flex;
    align-items: center;
    color: #ff111c;

    .item {
      width: 40px;
      height: 40px;
      font-size: 28px;
      background: #ffffff;
      border-radius: 8px;
      font-family: Bebas-Regular;
      color: currentColor;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }

    .divider {
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      background-image: url('./images/秒杀倒计时冒号.png');
      width: 6px;
      height: 20px;
      margin: 0 14px;
    }
  }
</style>
